export default {
  AUTHENTICATE: 'AUTHENTICATE',
  CLEAR_USER: 'LOGOUT',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_CURRENT_USER_AVAILABILITY: 'SET_CURRENT_USER_AVAILABILITY',
  SET_CURRENT_USER_AUTO_OFFLINE: 'SET_CURRENT_USER_AUTO_OFFLINE',
  RESET_ONBOARDING: 'RESET_ONBOARDING',
  SET_CURRENT_USER_UI_SETTINGS: 'SET_CURRENT_USER_UI_SETTINGS',
  SET_CURRENT_USER_UI_FLAGS: 'SET_CURRENT_USER_UI_FLAGS',

  // Chat List
  RECEIVE_CHAT_LIST: 'RECEIVE_CHAT_LIST',
  SET_ALL_CONVERSATION: 'SET_ALL_CONVERSATION',
  REPLACE_CONVERSATION_LIST: 'REPLACE_CONVERSATION_LIST',
  EMPTY_ALL_CONVERSATION: 'EMPTY_ALL_CONVERSATION',
  SET_CONV_TAB_META: 'SET_CONV_TAB_META',
  CLEAR_LIST_LOADING_STATUS: 'CLEAR_LIST_LOADING_STATUS',
  SET_LIST_LOADING_STATUS: 'SET_LIST_LOADING_STATUS',
  SET_ALL_MESSAGES_LOADED: 'SET_ALL_MESSAGES_LOADED',
  CLEAR_ALL_MESSAGES_LOADED: 'CLEAR_ALL_MESSAGES_LOADED',
  CHANGE_CHAT_STATUS_FILTER: 'CHANGE_CHAT_STATUS_FILTER',
  CHANGE_CHAT_SORT_FILTER: 'CHANGE_CHAT_SORT_FILTER',
  UPDATE_ASSIGNEE: 'UPDATE_ASSIGNEE',
  UPDATE_CONVERSATION_CONTACT: 'UPDATE_CONVERSATION_CONTACT',
  CLEAR_CONTACT_CONVERSATIONS: 'CLEAR_CONTACT_CONVERSATIONS',
  SET_CONVERSATION_FILTERS: 'SET_CONVERSATION_FILTERS',
  SET_CONVERSATION_FILTERS_SORT: 'SET_CONVERSATION_FILTERS_SORT',
  CLEAR_CONVERSATION_FILTERS: 'CLEAR_CONVERSATION_FILTERS',
  SET_CONVERSATION_LAST_SEEN: 'SET_CONVERSATION_LAST_SEEN',
  SET_LAST_MESSAGE_ID_IN_SYNC_CONVERSATION:
    'SET_LAST_MESSAGE_ID_FOR_SYNC_CONVERSATION',
  SET_DRAFT_MESSAGES: 'SET_DRAFT_MESSAGES',
  REMOVE_DRAFT_MESSAGES: 'REMOVE_DRAFT_MESSAGES',
  SET_REPLY_EDITOR_MODE: 'SET_REPLY_EDITOR_MODE',

  SET_CURRENT_CHAT_WINDOW: 'SET_CURRENT_CHAT_WINDOW',
  CLEAR_CURRENT_CHAT_WINDOW: 'CLEAR_CURRENT_CHAT_WINDOW',
  CLEAR_ALL_MESSAGES: 'CLEAR_ALL_MESSAGES',
  CHANGE_CONVERSATION_STATUS: 'CHANGE_CONVERSATION_STATUS',
  ADD_CONVERSATION: 'ADD_CONVERSATION',
  UPDATE_CONVERSATION: 'UPDATE_CONVERSATION',
  MUTE_CONVERSATION: 'MUTE_CONVERSATION',
  UNMUTE_CONVERSATION: 'UNMUTE_CONVERSATION',
  ASSIGN_AGENT: 'ASSIGN_AGENT',
  ASSIGN_TEAM: 'ASSIGN_TEAM',
  ASSIGN_PRIORITY: 'ASSIGN_PRIORITY',
  SET_CHAT_META: 'SET_CHAT_META',
  ADD_MESSAGE: 'ADD_MESSAGE',
  SET_AUTO_TRANSLATING: 'SET_AUTO_TRANSLATING',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  ADD_PENDING_MESSAGE: 'ADD_PENDING_MESSAGE',
  UPDATE_MESSAGE_UNREAD_COUNT: 'UPDATE_MESSAGE_UNREAD_COUNT',
  SET_PREVIOUS_CONVERSATIONS: 'SET_PREVIOUS_CONVERSATIONS',
  SET_ACTIVE_INBOX: 'SET_ACTIVE_INBOX',
  UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES:
    'UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES',
  UPDATE_CONVERSATION_LAST_ACTIVITY: 'UPDATE_CONVERSATION_LAST_ACTIVITY',
  UPDATE_MESSAGE_CALL_STATUS: 'UPDATE_MESSAGE_CALL_STATUS',
  SET_MISSING_MESSAGES: 'SET_MISSING_MESSAGES',

  SET_ALL_ATTACHMENTS: 'SET_ALL_ATTACHMENTS',
  ADD_CONVERSATION_ATTACHMENTS: 'ADD_CONVERSATION_ATTACHMENTS',
  DELETE_CONVERSATION_ATTACHMENTS: 'DELETE_CONVERSATION_ATTACHMENTS',
  DELETE_CONVERSATION: 'DELETE_CONVERSATION',

  SET_CONVERSATION_CAN_REPLY: 'SET_CONVERSATION_CAN_REPLY',

  SET_CONTEXT_MENU_CHAT_ID: 'SET_CONTEXT_MENU_CHAT_ID',

  SET_CHAT_DATA_FETCHED: 'SET_CHAT_DATA_FETCHED',
  SET_CHAT_LIST_FILTERS: 'SET_CHAT_LIST_FILTERS',
  UPDATE_CHAT_LIST_FILTERS: 'UPDATE_CHAT_LIST_FILTERS',

  // Conversation inbox connected copilot assistant
  SET_INBOX_CAPTAIN_ASSISTANT: 'SET_INBOX_CAPTAIN_ASSISTANT',

  // Inboxes
  SET_INBOXES_UI_FLAG: 'SET_INBOXES_UI_FLAG',
  SET_INBOXES: 'SET_INBOXES',
  SET_INBOX_ITEM: 'SET_INBOX_ITEM',
  ADD_INBOXES: 'ADD_INBOXES',
  EDIT_INBOXES: 'EDIT_INBOXES',
  DELETE_INBOXES: 'DELETE_INBOXES',

  // Agent
  SET_ACCOUNT_UI_FLAG: 'SET_ACCOUNT_UI_FLAG',
  SET_ACCOUNT_LIMITS: 'SET_ACCOUNT_LIMITS',
  SET_ACCOUNTS: 'SET_ACCOUNTS',
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  EDIT_ACCOUNT: 'EDIT_ACCOUNT',
  DELETE_ACCOUNT: 'DELETE_AGENT',

  // Agent
  SET_AGENT_FETCHING_STATUS: 'SET_AGENT_FETCHING_STATUS',
  SET_AGENT_CREATING_STATUS: 'SET_AGENT_CREATING_STATUS',
  SET_AGENT_UPDATING_STATUS: 'SET_AGENT_UPDATING_STATUS',
  SET_AGENT_DELETING_STATUS: 'SET_AGENT_DELETING_STATUS',
  SET_AGENTS: 'SET_AGENTS',
  ADD_AGENT: 'ADD_AGENT',
  EDIT_AGENT: 'EDIT_AGENT',
  DELETE_AGENT: 'DELETE_AGENT',
  UPDATE_AGENTS_PRESENCE: 'UPDATE_AGENTS_PRESENCE',
  UPDATE_SINGLE_AGENT_PRESENCE: 'UPDATE_SINGLE_AGENT_PRESENCE',

  // Canned Response
  SET_CANNED_UI_FLAG: 'SET_CANNED_UI_FLAG',
  SET_CANNED: 'SET_CANNED',
  ADD_CANNED: 'ADD_CANNED',
  EDIT_CANNED: 'EDIT_CANNED',
  DELETE_CANNED: 'DELETE_CANNED',

  // Custom Role
  SET_CUSTOM_ROLE_UI_FLAG: 'SET_CUSTOM_ROLE_UI_FLAG',
  SET_CUSTOM_ROLE: 'SET_CUSTOM_ROLE',
  ADD_CUSTOM_ROLE: 'ADD_CUSTOM_ROLE',
  EDIT_CUSTOM_ROLE: 'EDIT_CUSTOM_ROLE',
  DELETE_CUSTOM_ROLE: 'DELETE_CUSTOM_ROLE',

  // Labels
  SET_LABEL_UI_FLAG: 'SET_LABEL_UI_FLAG',
  SET_LABELS: 'SET_LABELS',
  ADD_LABEL: 'ADD_LABEL',
  EDIT_LABEL: 'EDIT_LABEL',
  DELETE_LABEL: 'DELETE_LABEL',

  // Integrations
  SET_INTEGRATIONS_UI_FLAG: 'SET_INTEGRATIONS_UI_FLAG',
  SET_INTEGRATIONS: 'SET_INTEGRATIONS',
  ADD_INTEGRATION: 'ADD_INTEGRATION',
  DELETE_INTEGRATION: 'DELETE_INTEGRATION',
  ADD_INTEGRATION_HOOKS: 'ADD_INTEGRATION_HOOKS',
  DELETE_INTEGRATION_HOOKS: 'DELETE_INTEGRATION_HOOKS',

  // WebHook
  SET_WEBHOOK_UI_FLAG: 'SET_WEBHOOK_UI_FLAG',
  SET_WEBHOOK: 'SET_WEBHOOK',
  ADD_WEBHOOK: 'ADD_WEBHOOK',
  DELETE_WEBHOOK: 'DELETE_WEBHOOK',
  UPDATE_WEBHOOK: 'UPDATE_WEBHOOK',

  // Contacts
  SET_CONTACT_META: 'SET_CONTACT_META',
  SET_CONTACT_UI_FLAG: 'SET_CONTACT_UI_FLAG',
  SET_CONTACT_ITEM: 'SET_CONTACT_ITEM',
  SET_CONTACT_ATTACHMENTS: 'SET_CONTACT_ATTACHMENTS',
  SET_CONTACTS: 'SET_CONTACTS',
  APPEND_CONTACTS: 'APPEND_CONTACTS',
  CLEAR_CONTACTS: 'CLEAR_CONTACTS',
  EDIT_CONTACT: 'EDIT_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACTS_PRESENCE: 'UPDATE_CONTACTS_PRESENCE',
  SET_CONTACT_FILTERS: 'SET_CONTACT_FILTERS',
  CLEAR_CONTACT_FILTERS: 'CLEAR_CONTACT_FILTERS',

  // Notifications
  SET_NOTIFICATIONS_META: 'SET_NOTIFICATIONS_META',
  SET_NOTIFICATIONS_UNREAD_COUNT: 'SET_NOTIFICATIONS_UNREAD_COUNT',
  SET_NOTIFICATIONS_UI_FLAG: 'SET_NOTIFICATIONS_UI_FLAG',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  READ_NOTIFICATION: 'READ_NOTIFICATION',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
  UPDATE_ALL_NOTIFICATIONS: 'UPDATE_ALL_NOTIFICATIONS',
  SET_NOTIFICATIONS_ITEM: 'SET_NOTIFICATIONS_ITEM',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  EDIT_NOTIFICATIONS: 'EDIT_NOTIFICATIONS',
  UPDATE_NOTIFICATIONS_PRESENCE: 'UPDATE_NOTIFICATIONS_PRESENCE',
  SET_ALL_NOTIFICATIONS_LOADED: 'SET_ALL_NOTIFICATIONS_LOADED',
  DELETE_READ_NOTIFICATIONS: 'DELETE_READ_NOTIFICATIONS',
  DELETE_ALL_NOTIFICATIONS: 'DELETE_ALL_NOTIFICATIONS',
  SNOOZE_NOTIFICATION: 'SNOOZE_NOTIFICATION',
  SET_NOTIFICATION_FILTERS: 'SET_NOTIFICATION_FILTERS',
  UPDATE_NOTIFICATION_FILTERS: 'UPDATE_NOTIFICATION_FILTERS',

  // Contact Conversation
  SET_CONTACT_CONVERSATIONS_UI_FLAG: 'SET_CONTACT_CONVERSATIONS_UI_FLAG',
  SET_CONTACT_CONVERSATIONS: 'SET_CONTACT_CONVERSATIONS',
  ADD_CONTACT_CONVERSATION: 'ADD_CONTACT_CONVERSATION',
  DELETE_CONTACT_CONVERSATION: 'DELETE_CONTACT_CONVERSATION',
  SET_CONVERSATION_NEIGHBOURS: 'SET_CONVERSATION_NEIGHBOURS',

  // Contact Label
  SET_CONTACT_LABELS_UI_FLAG: 'SET_CONTACT_LABELS_UI_FLAG',
  SET_CONTACT_LABELS: 'SET_CONTACT_LABELS',

  // Conversation Label
  SET_CONVERSATION_LABELS_UI_FLAG: 'SET_CONVERSATION_LABELS_UI_FLAG',
  SET_CONVERSATION_LABELS: 'SET_CONVERSATION_LABELS',
  SET_BULK_CONVERSATION_LABELS: 'SET_BULK_CONVERSATION_LABELS',
  SET_SELECTED_CONVERSATION_IDS: 'SET_SELECTED_CONVERSATION_IDS',
  CLEAR_SELECTED_CONVERSATION_IDS: 'CLEAR_SELECTED_CONVERSATION_IDS',
  REMOVE_SELECTED_CONVERSATION_IDS: 'REMOVE_SELECTED_CONVERSATION_IDS',

  // Conversation Unread Counts
  SET_CONVERSATION_UNREAD_COUNTS: 'SET_CONVERSATION_UNREAD_COUNTS',

  // Reports
  SET_ACCOUNT_REPORTS: 'SET_ACCOUNT_REPORTS',
  SET_HEATMAP_DATA: 'SET_HEATMAP_DATA',
  TOGGLE_HEATMAP_LOADING: 'TOGGLE_HEATMAP_LOADING',
  SET_RESOLUTION_HEATMAP_DATA: 'SET_RESOLUTION_HEATMAP_DATA',
  TOGGLE_RESOLUTION_HEATMAP_LOADING: 'TOGGLE_RESOLUTION_HEATMAP_LOADING',
  SET_ACCOUNT_SUMMARY: 'SET_ACCOUNT_SUMMARY',
  SET_BOT_SUMMARY: 'SET_BOT_SUMMARY',
  TOGGLE_ACCOUNT_REPORT_LOADING: 'TOGGLE_ACCOUNT_REPORT_LOADING',
  SET_BOT_SUMMARY_STATUS: 'SET_BOT_SUMMARY_STATUS',
  SET_ACCOUNT_SUMMARY_STATUS: 'SET_ACCOUNT_SUMMARY_STATUS',
  SET_ACCOUNT_CONVERSATION_METRIC: 'SET_ACCOUNT_CONVERSATION_METRIC',
  TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING',
  SET_AGENT_CONVERSATION_METRIC: 'SET_AGENT_CONVERSATION_METRIC',
  TOGGLE_AGENT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_AGENT_CONVERSATION_METRIC_LOADING',

  // Conversation Metadata
  SET_CONVERSATION_METADATA: 'SET_CONVERSATION_METADATA',

  // Conversation Page
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_CONVERSATION_END_REACHED: 'SET_CONVERSATION_END_REACHED',
  CLEAR_CONVERSATION_PAGE: 'CLEAR_CONVERSATION_PAGE',

  // Notification Settings
  SET_USER_NOTIFICATION_UI_FLAG: 'SET_USER_NOTIFICATION_UI_FLAG',
  SET_USER_NOTIFICATION: 'SET_USER_NOTIFICATION',

  // User Typing
  ADD_USER_TYPING_TO_CONVERSATION: 'ADD_USER_TYPING_TO_CONVERSATION',
  REMOVE_USER_TYPING_FROM_CONVERSATION: 'REMOVE_USER_TYPING_FROM_CONVERSATION',

  // Conversation Search
  SEARCH_CONVERSATIONS_SET: 'SEARCH_CONVERSATIONS_SET',
  SEARCH_CONVERSATIONS_SET_UI_FLAG: 'SEARCH_CONVERSATIONS_SET_UI_FLAG',

  // Campaigns
  SET_CAMPAIGN_UI_FLAG: 'SET_CAMPAIGN_UI_FLAG',
  SET_CAMPAIGNS: 'SET_CAMPAIGNS',
  ADD_CAMPAIGN: 'ADD_CAMPAIGN',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  DELETE_CAMPAIGN: 'DELETE_CAMPAIGN',

  // Contact notes
  SET_CONTACT_NOTES_UI_FLAG: 'SET_CONTACT_NOTES_UI_FLAG',
  SET_CONTACT_NOTES: 'SET_CONTACT_NOTES',
  ADD_CONTACT_NOTE: 'ADD_CONTACT_NOTE',
  EDIT_CONTACT_NOTE: 'EDIT_CONTACT_NOTE',
  DELETE_CONTACT_NOTE: 'DELETE_CONTACT_NOTE',

  // CSAT Responses
  SET_CSAT_RESPONSE_UI_FLAG: 'SET_CSAT_RESPONSE_UI_FLAG',
  SET_CSAT_RESPONSE: 'SET_CSAT_RESPONSE',
  SET_CSAT_RESPONSE_METRICS: 'SET_CSAT_RESPONSE_METRICS',
  UPDATE_CSAT_RESPONSE: 'UPDATE_CSAT_RESPONSE',

  // Custom Attributes
  SET_CUSTOM_ATTRIBUTE_UI_FLAG: 'SET_CUSTOM_ATTRIBUTE_UI_FLAG',
  SET_CUSTOM_ATTRIBUTE: 'SET_CUSTOM_ATTRIBUTE',
  ADD_CUSTOM_ATTRIBUTE: 'ADD_CUSTOM_ATTRIBUTE',
  EDIT_CUSTOM_ATTRIBUTE: 'EDIT_CUSTOM_ATTRIBUTE',
  DELETE_CUSTOM_ATTRIBUTE: 'DELETE_CUSTOM_ATTRIBUTE',

  // Automations
  SET_AUTOMATION_UI_FLAG: 'SET_AUTOMATION_UI_FLAG',
  SET_AUTOMATIONS: 'SET_AUTOMATIONS',
  ADD_AUTOMATION: 'ADD_AUTOMATION',
  EDIT_AUTOMATION: 'EDIT_AUTOMATION',
  DELETE_AUTOMATION: 'DELETE_AUTOMATION',

  // Custom Views
  SET_CUSTOM_VIEW_UI_FLAG: 'SET_CUSTOM_VIEW_UI_FLAG',
  SET_CUSTOM_VIEW: 'SET_CUSTOM_VIEW',
  ADD_CUSTOM_VIEW: 'ADD_CUSTOM_VIEW',
  UPDATE_CUSTOM_VIEW: 'UPDATE_CUSTOM_VIEW',
  DELETE_CUSTOM_VIEW: 'DELETE_CUSTOM_VIEW',
  SET_ACTIVE_CONVERSATION_FOLDER: 'SET_ACTIVE_CONVERSATION_FOLDER',

  // Bulk Actions
  SET_BULK_ACTIONS_FLAG: 'SET_BULK_ACTIONS_FLAG',

  // Dashboard Apps
  SET_DASHBOARD_APPS_UI_FLAG: 'SET_DASHBOARD_APPS_UI_FLAG',
  SET_DASHBOARD_APPS: 'SET_DASHBOARD_APPS',
  CREATE_DASHBOARD_APP: 'CREATE_DASHBOARD_APP',
  EDIT_DASHBOARD_APP: 'EDIT_DASHBOARD_APP',
  DELETE_DASHBOARD_APP: 'DELETE_DASHBOARD_APP',

  // Help center
  ADD_ARTICLE: 'ADD_ARTICLE',
  ADD_ARTICLE_ID: 'ADD_ARTICLE_ID',
  ADD_MANY_ARTICLES: 'ADD_MANY_ARTICLES',
  ADD_MANY_ARTICLES_ID: 'ADD_MANY_ARTICLES_ID',
  SET_ARTICLES_META: 'SET_ARTICLES_META',
  UPDATE_ARTICLE_FLAG: 'UPDATE_ARTICLE_FLAG',
  ADD_ARTICLE_FLAG: 'ADD_ARTICLE_FLAG',
  UPDATE_ARTICLE: 'UPDATE_ARTICLE',
  CLEAR_ARTICLES: 'CLEAR_ARTICLES',
  REMOVE_ARTICLE: 'REMOVE_ARTICLE',
  REMOVE_ARTICLE_ID: 'REMOVE_ARTICLE_ID',
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_ARTICLE_POSITIONS: 'SET_ARTICLE_POSITIONS',

  // Help Center -- Categories
  ADD_CATEGORY: 'ADD_CATEGORY',
  ADD_CATEGORY_ID: 'ADD_CATEGORY_ID',
  ADD_MANY_CATEGORIES: 'ADD_MANY_CATEGORIES',
  ADD_MANY_CATEGORIES_ID: 'ADD_MANY_CATEGORIES_ID',
  ADD_CATEGORY_FLAG: 'ADD_CATEGORY_FLAG',
  CLEAR_CATEGORIES: 'CLEAR_CATEGORIES',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',
  REMOVE_CATEGORY_ID: 'REMOVE_CATEGORY_ID',
  SET_CATEGORY_POSITIONS: 'SET_CATEGORY_POSITIONS',

  // Agent Bots
  SET_AGENT_BOT_UI_FLAG: 'SET_AGENT_BOT_UI_FLAG',
  SET_AGENT_BOTS: 'SET_AGENT_BOTS',
  ADD_AGENT_BOT: 'ADD_AGENT_BOT',
  EDIT_AGENT_BOT: 'EDIT_AGENT_BOT',
  DELETE_AGENT_BOT: 'DELETE_AGENT_BOT',
  SET_AGENT_BOT_INBOX: 'SET_AGENT_BOT_INBOX',
  UPDATE_AGENT_BOT_AVATAR: 'UPDATE_AGENT_BOT_AVATAR',

  // Wgpt Audit Trail
  SET_WGPT_AUDIT_TRAIL_UI_FLAG: 'SET_WGPT_AUDIT_TRAIL_UI_FLAG',
  SET_WGPT_AUDIT_TRAIL: 'SET_WGPT_AUDIT_TRAIL',
  SET_WGPT_AUDIT_TRAIL_META: 'SET_WGPT_AUDIT_TRAIL_META',
  SET_WGPT_AUDIT_TRAIL_APPLIED_FILTERS: 'SET_WGPT_AUDIT_TRAIL_APPLIED_FILTERS',

  // Wgpt Boards
  SET_WGPT_BOARD_UI_FLAG: 'SET_WGPT_BOARD_UI_FLAG',
  SET_WGPT_BOARDS: 'SET_WGPT_BOARDS',
  ADD_WGPT_BOARD: 'ADD_WGPT_BOARD',
  EDIT_WGPT_BOARD: 'EDIT_WGPT_BOARD',
  DELETE_WGPT_BOARD: 'DELETE_WGPT_BOARD',
  SET_WGPT_BOARD_AUTOMATIONS: 'SET_WGPT_BOARD_AUTOMATIONS',

  // Wgpt Social Media Posts
  SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG: 'SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG',
  SET_WGPT_SOCIAL_MEDIA_POSTS: 'SET_WGPT_SOCIAL_MEDIA_POSTS',
  SET_WGPT_SOCIAL_MEDIA_POSTS_META: 'SET_WGPT_SOCIAL_MEDIA_POSTS_META',
  ADD_WGPT_SOCIAL_MEDIA_POST: 'ADD_WGPT_SOCIAL_MEDIA_POST',

  // Wgpt Board Lists
  SET_WGPT_BOARD_LIST_UI_FLAG: 'SET_WGPT_BOARD_LIST_UI_FLAG',
  SET_WGPT_BOARD_LISTS: 'SET_WGPT_BOARD_LISTS',
  EMPTY_WGPT_BOARD_LIST: 'EMPTY_WGPT_BOARD_LIST',
  ADD_WGPT_BOARD_LIST: 'ADD_WGPT_BOARD_LIST',
  EDIT_WGPT_BOARD_LIST: 'EDIT_WGPT_BOARD_LIST',
  DELETE_WGPT_BOARD_LIST: 'DELETE_WGPT_BOARD_LIST',
  SET_WGPT_BOARD_LIST_CARDS_COUNTS: 'SET_WGPT_BOARD_LIST_CARDS_COUNTS',

  // Wgpt Board List Cards
  SET_WGPT_BOARD_LIST_CARD_UI_FLAG: 'SET_WGPT_BOARD_LIST_CARD_UI_FLAG',
  SET_WGPT_BOARD_LIST_CARDS: 'SET_WGPT_BOARD_LIST_CARDS',
  SET_WGPT_BOARD_LIST_CARD_ACTIVE: 'SET_WGPT_BOARD_LIST_CARD_ACTIVE',
  EMPTY_WGPT_BOARD_LIST_CARD: 'EMPTY_WGPT_BOARD_LIST_CARD',
  ADD_WGPT_BOARD_LIST_CARD: 'ADD_WGPT_BOARD_LIST_CARD',
  ADD_WGPT_BOARD_LIST_CARDS: 'ADD_WGPT_BOARD_LIST_CARDS',
  EDIT_WGPT_BOARD_LIST_CARD: 'EDIT_WGPT_BOARD_LIST_CARD',
  DELETE_WGPT_BOARD_LIST_CARD: 'DELETE_WGPT_BOARD_LIST_CARD',
  DELETE_WGPT_BOARD_LIST_CARD_BY_ORIGINAL_ID:
    'DELETE_WGPT_BOARD_LIST_CARD_BY_ORIGINAL_ID',
  ADD_WGPT_BOARD_LIST_CARD_ATTACHMENT: 'ADD_WGPT_BOARD_LIST_CARD_ATTACHMENT',
  DELETE_WGPT_BOARD_LIST_CARD_ATTACHMENT:
    'DELETE_WGPT_BOARD_LIST_CARD_ATTACHMENT',
  SET_WGPT_BOARD_LIST_CARDS_FILTER: 'SET_WGPT_BOARD_LIST_CARDS_FILTER',

  // Wgpt Board List Card Activities
  SET_WGPT_BOARD_LIST_CARD_ACTIVITY_UI_FLAG:
    'SET_WGPT_BOARD_LIST_CARD_ACTIVITY_UI_FLAG',
  EMPTY_WGPT_BOARD_LIST_CARD_ACTIVITY: 'EMPTY_WGPT_BOARD_LIST_CARD_ACTIVITY',
  ADD_WGPT_BOARD_LIST_CARD_ACTIVITY: 'ADD_WGPT_BOARD_LIST_CARD_ACTIVITY',
  SET_WGPT_BOARD_LIST_CARD_ACTIVITIES: 'SET_WGPT_BOARD_LIST_CARD_ACTIVITIES',
  ADD_WGPT_BOARD_LIST_CARD_ACTIVITIES: 'ADD_WGPT_BOARD_LIST_CARD_ACTIVITIES',
  EDIT_WGPT_BOARD_LIST_CARD_ACTIVITY: 'EDIT_WGPT_BOARD_LIST_CARD_ACTIVITY',
  DELETE_WGPT_BOARD_LIST_CARD_ACTIVITY: 'DELETE_WGPT_BOARD_LIST_CARD_ACTIVITY',

  // Wgpt Board List Card Automations
  SET_WGPT_BOARD_LIST_CARD_AUTOMATION_UI_FLAG:
    'SET_WGPT_BOARD_LIST_CARD_AUTOMATION_UI_FLAG',
  SET_WGPT_BOARD_LIST_CARD_AUTOMATIONS: 'SET_WGPT_BOARD_LIST_CARD_AUTOMATIONS',

  // Wgpt Automations
  SET_WGPT_AUTOMATION_UI_FLAG: 'SET_WGPT_AUTOMATION_UI_FLAG',
  SET_WGPT_AUTOMATIONS: 'SET_WGPT_AUTOMATIONS',
  SET_WGPT_AUTOMATIONS_LIST: 'SET_WGPT_AUTOMATIONS_LIST',
  ADD_WGPT_AUTOMATION: 'ADD_WGPT_AUTOMATION',
  EDIT_WGPT_AUTOMATION: 'EDIT_WGPT_AUTOMATION',
  DELETE_WGPT_AUTOMATION: 'DELETE_WGPT_AUTOMATION',
  SET_WGPT_AUTOMATION_ACTION_CLIPBOARD: 'SET_WGPT_AUTOMATION_ACTION_CLIPBOARD',

  // Wgpt Boards Automation Registry
  SET_WGPT_BOARDS_AUTOMATION_REGISTRY_UI_FLAG:
    'SET_WGPT_BOARDS_AUTOMATION_REGISTRY_UI_FLAG',
  ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_FIELDS:
    'ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_FIELDS',
  ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_CUSTOM_OPTIONS:
    'ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_CUSTOM_OPTIONS',
  ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_CUSTOM_OBJECTS:
    'ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_CUSTOM_OBJECTS',
  ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_DYNAMIC_ARRAYS:
    'ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_DYNAMIC_ARRAYS',
  ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_DYNAMIC_FLAGS:
    'ADD_WGPT_BOARDS_AUTOMATION_REGISTRY_DYNAMIC_FLAGS',
  SET_WGPT_BOARDS_AUTOMATION_REGISTRY_TRIGGERS:
    'SET_WGPT_BOARDS_AUTOMATION_REGISTRY_TRIGGERS',
  SET_WGPT_BOARDS_AUTOMATION_REGISTRY_ACTIONS:
    'SET_WGPT_BOARDS_AUTOMATION_REGISTRY_ACTIONS',
  SET_WGPT_BOARDS_AUTOMATION_REGISTRY_LOGICAL_OPERATORS:
    'SET_WGPT_BOARDS_AUTOMATION_REGISTRY_LOGICAL_OPERATORS',
  SET_WGPT_BOARDS_AUTOMATION_REGISTRY_COMPARISON_OPERATORS:
    'SET_WGPT_BOARDS_AUTOMATION_REGISTRY_COMPARISON_OPERATORS',
  SET_WGPT_BOARDS_AUTOMATION_REGISTRY_TEMPLATES:
    'SET_WGPT_BOARDS_AUTOMATION_REGISTRY_TEMPLATES',

  // Wgpt Automations Builder
  SET_WGPT_AUTOMATION_BUILDER_UI_FLAG: 'SET_WGPT_AUTOMATION_BUILDER_UI_FLAG',
  SET_WGPT_AUTOMATION_BUILDER: 'SET_WGPT_AUTOMATION_BUILDER',
  RESET_WGPT_AUTOMATION_BUILDER: 'RESET_WGPT_AUTOMATION_BUILDER',

  // Wgpt Bots
  SET_WGPT_BOT_UI_FLAG: 'SET_WGPT_BOT_UI_FLAG',
  SET_WGPT_BOTS: 'SET_WGPT_BOTS',
  ADD_WGPT_BOT: 'ADD_WGPT_BOT',
  EDIT_WGPT_BOT: 'EDIT_WGPT_BOT',
  DELETE_WGPT_BOT: 'DELETE_WGPT_BOT',
  DELETE_WGPT_BOT_AVATAR: 'DELETE_WGPT_BOT_AVATAR',
  SET_WGPT_BOT_INBOX: 'SET_WGPT_BOT_INBOX',
  SEARCH_WGPT_BOT_CHUNKS: 'SEARCH_WGPT_BOT_CHUNKS',
  EMPTY_SEARCH_WGPT_BOT_CHUNKS: 'EMPTY_SEARCH_WGPT_BOT_CHUNKS',
  SET_WGPT_BOT_TEMPLATES: 'SET_WGPT_BOT_TEMPLATES',

  // Wgpt Bot Workflows
  SET_WGPT_BOT_WORKFLOW_UI_FLAG: 'SET_WGPT_BOT_WORKFLOW_UI_FLAG',
  SET_WGPT_BOT_WORKFLOWS: 'SET_WGPT_BOT_WORKFLOWS',
  ADD_WGPT_BOT_WORKFLOW: 'ADD_WGPT_BOT_WORKFLOW',
  EDIT_WGPT_BOT_WORKFLOW: 'EDIT_WGPT_BOT_WORKFLOW',
  DELETE_WGPT_BOT_WORKFLOW: 'DELETE_WGPT_BOT_WORKFLOW',
  SET_WGPT_BOT_WORKFLOW_LLM_CONFIGS: 'SET_WGPT_BOT_WORKFLOW_LLM_CONFIGS',

  // Wgpt Bot Workflow Stages
  SET_WGPT_BOT_WORKFLOW_STAGE_UI_FLAG: 'SET_WGPT_BOT_WORKFLOW_STAGE_UI_FLAG',
  SET_WGPT_BOT_WORKFLOW_STAGES: 'SET_WGPT_BOT_WORKFLOW_STAGES',
  EMPTY_WGPT_BOT_WORKFLOW_STAGES: 'EMPTY_WGPT_BOT_WORKFLOW_STAGES',
  ADD_WGPT_BOT_WORKFLOW_STAGE: 'ADD_WGPT_BOT_WORKFLOW_STAGE',
  EDIT_WGPT_BOT_WORKFLOW_STAGE: 'EDIT_WGPT_BOT_WORKFLOW_STAGE',
  DELETE_WGPT_BOT_WORKFLOW_STAGE: 'DELETE_WGPT_BOT_WORKFLOW_STAGE',

  // Wgpt Bot Sources
  SET_WGPT_BOT_SOURCE_UI_FLAG: 'SET_WGPT_BOT_SOURCE_UI_FLAG',
  SET_WGPT_BOT_SOURCES: 'SET_WGPT_BOT_SOURCES',
  ADD_WGPT_BOT_SOURCE: 'ADD_WGPT_BOT_SOURCE',
  EDIT_WGPT_BOT_SOURCE: 'EDIT_WGPT_BOT_SOURCE',
  DELETE_WGPT_BOT_SOURCE: 'DELETE_WGPT_BOT_SOURCE',

  // Wgpt Bot Sources Chunks
  SET_WGPT_BOT_SOURCE_CHUNK_UI_FLAG: 'SET_WGPT_BOT_SOURCE_CHUNK_UI_FLAG',
  SET_WGPT_BOT_SOURCE_CHUNKS: 'SET_WGPT_BOT_SOURCE_CHUNKS',
  EMPTY_WGPT_BOT_SOURCE_CHUNKS: 'EMPTY_WGPT_BOT_SOURCE_CHUNKS',
  ADD_WGPT_BOT_SOURCE_CHUNK: 'ADD_WGPT_BOT_SOURCE_CHUNK',
  EDIT_WGPT_BOT_SOURCE_CHUNK: 'EDIT_WGPT_BOT_SOURCE_CHUNK',
  DELETE_WGPT_BOT_SOURCE_CHUNK: 'DELETE_WGPT_BOT_SOURCE_CHUNK',

  // Wgpt Bot Sources Chunks
  SEARCH_SOURCE_CHUNKS_SET: 'SEARCH_SOURCE_CHUNKS_SET',
  SOURCE_CHUNK_SEARCH_SET: 'SOURCE_CHUNK_SEARCH_SET',
  SEARCH_SOURCE_CHUNKS_SET_UI_FLAG: 'SEARCH_SOURCE_CHUNKS_SET_UI_FLAG',
  FULL_SEARCH_SOURCE_CHUNKS_SET_UI_FLAG:
    'FULL_SEARCH_SOURCE_CHUNKS_SET_UI_FLAG',
  SOURCE_CHUNK_SEARCH_SET_UI_FLAG: 'SOURCE_CHUNK_SEARCH_SET_UI_FLAG',

  // Wgpt Bot Knowledge Manager
  SET_WGPT_KNOWLEDGE_MANAGER_UI_FLAG: 'SET_WGPT_KNOWLEDGE_MANAGER_UI_FLAG',
  ADD_WGPT_KNOWLEDGE_MANAGER_MESSAGE: 'ADD_WGPT_KNOWLEDGE_MANAGER_MESSAGE',
  SET_WGPT_KNOWLEDGE_MANAGER_MESSAGES: 'SET_WGPT_KNOWLEDGE_MANAGER_MESSAGES',
  SET_WGPT_KNOWLEDGE_MANAGER_KNOWLEDGE: 'SET_WGPT_KNOWLEDGE_MANAGER_KNOWLEDGE',
  SET_WGPT_KNOWLEDGE_MANAGER_BOT_ID: 'SET_WGPT_KNOWLEDGE_MANAGER_BOT_ID',
  REMOVE_WGPT_KNOWLEDGE_MANAGER_PENDING_MESSAGES:
    'REMOVE_WGPT_KNOWLEDGE_MANAGER_PENDING_MESSAGES',

  // WgptCampaign
  SET_WGPT_CAMPAIGNS: 'SET_WGPT_CAMPAIGNS',
  ADD_WGPT_CAMPAIGN: 'ADD_WGPT_CAMPAIGN',
  EDIT_WGPT_CAMPAIGN: 'EDIT_WGPT_CAMPAIGN',
  SET_WGPT_CAMPAIGN_TARGET_DETAILS: 'SET_WGPT_CAMPAIGN_TARGET_DETAILS',
  DELETE_WGPT_CAMPAIGN: 'DELETE_WGPT_CAMPAIGN',
  SET_WGPT_CAMPAIGN_UI_FLAG: 'SET_WGPT_CAMPAIGN_UI_FLAG',
  REMOVE_WGPT_CAMPAIGN_FILE: 'REMOVE_WGPT_CAMPAIGN_FILE',

  // WgptCarListing
  SET_WGPT_CAR_LISTINGS: 'SET_WGPT_CAR_LISTINGS',
  APPEND_WGPT_CAR_LISTINGS: 'APPEND_WGPT_CAR_LISTINGS',
  SET_WGPT_CAR_LISTING_META: 'SET_WGPT_CAR_LISTING_META',
  ADD_WGPT_CAR_LISTING: 'ADD_WGPT_CAR_LISTING',
  EDIT_WGPT_CAR_LISTING: 'EDIT_WGPT_CAR_LISTING',
  DELETE_WGPT_CAR_LISTING: 'DELETE_WGPT_CAR_LISTING',
  SET_WGPT_CAR_LISTING_UI_FLAG: 'SET_WGPT_CAR_LISTING_UI_FLAG',

  // WgptCarShowroom
  SET_WGPT_CAR_SHOWROOM: 'SET_WGPT_CAR_SHOWROOM',
  SET_WGPT_CAR_SHOWROOM_UI_FLAG: 'SET_WGPT_CAR_SHOWROOM_UI_FLAG',

  // WgptCarCatalog
  SET_WGPT_CAR_CATALOG: 'SET_WGPT_CAR_CATALOG',
  SET_WGPT_CAR_CATALOG_MODELS: 'SET_WGPT_CAR_CATALOG_MODELS',
  SET_WGPT_CAR_CATALOG_TRIMS: 'SET_WGPT_CAR_CATALOG_TRIMS',
  ADD_WGPT_CAR_CATALOG_ITEM: 'ADD_WGPT_CAR_CATALOG_ITEM',
  UPDATE_WGPT_CAR_CATALOG_ITEM: 'UPDATE_WGPT_CAR_CATALOG_ITEM',
  SET_WGPT_CAR_CATALOG_UI_FLAG: 'SET_WGPT_CAR_CATALOG_UI_FLAG',

  // WgptReports
  SET_WGPT_REPORTS_UI_FLAG: 'SET_WGPT_REPORTS_UI_FLAG',
  SET_WGPT_CAMPAIGN_REPORT: 'SET_WGPT_CAMPAIGN_REPORT',

  // Contact Cards
  SET_WGPT_CONTACT_CARD_UI_FLAG: 'SET_WGPT_CONTACT_CARD_UI_FLAG',
  SET_WGPT_CONTACT_CARDS: 'SET_WGPT_CONTACT_CARDS',

  // Wgpt Bot Tools
  SET_WGPT_BOT_TOOL_UI_FLAG: 'SET_WGPT_BOT_TOOL_UI_FLAG',
  SET_WGPT_BOT_TOOLS: 'SET_WGPT_BOT_TOOLS',
  ADD_WGPT_BOT_TOOL: 'ADD_WGPT_BOT_TOOL',
  EDIT_WGPT_BOT_TOOL: 'EDIT_WGPT_BOT_TOOL',
  DELETE_WGPT_BOT_TOOL: 'DELETE_WGPT_BOT_TOOL',
  SET_WGPT_BOT_TOOL_EXECUTIONS_UI_FLAG: 'SET_WGPT_BOT_TOOL_EXECUTIONS_UI_FLAG',
  SET_WGPT_BOT_TOOL_EXECUTIONS: 'SET_WGPT_BOT_TOOL_EXECUTIONS',
  SET_WGPT_BOT_TOOL_EXECUTIONS_META: 'SET_WGPT_BOT_TOOL_EXECUTIONS_META',

  // WGPT MCP servers
  SET_WGPT_MCP_SERVER_UI_FLAG: 'SET_WGPT_MCP_SERVER_UI_FLAG',
  SET_WGPT_MCP_SERVERS: 'SET_WGPT_MCP_SERVERS',
  ADD_WGPT_MCP_SERVER: 'ADD_WGPT_MCP_SERVER',
  EDIT_WGPT_MCP_SERVER: 'EDIT_WGPT_MCP_SERVER',
  DELETE_WGPT_MCP_SERVER: 'DELETE_WGPT_MCP_SERVER',
  SET_WGPT_MCP_SERVER_EXECUTIONS_UI_FLAG:
    'SET_WGPT_MCP_SERVER_EXECUTIONS_UI_FLAG',
  SET_WGPT_MCP_SERVER_EXECUTIONS: 'SET_WGPT_MCP_SERVER_EXECUTIONS',
  SET_WGPT_MCP_SERVER_EXECUTIONS_META: 'SET_WGPT_MCP_SERVER_EXECUTIONS_META',

  // Wgpt Bot Eval Criteria
  SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG: 'SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG',
  SET_WGPT_BOT_EVAL_CRITERIA: 'SET_WGPT_BOT_EVAL_CRITERIA',
  ADD_WGPT_BOT_EVAL_CRITERION: 'ADD_WGPT_BOT_EVAL_CRITERION',
  EDIT_WGPT_BOT_EVAL_CRITERION: 'EDIT_WGPT_BOT_EVAL_CRITERION',
  DELETE_WGPT_BOT_EVAL_CRITERION: 'DELETE_WGPT_BOT_EVAL_CRITERION',

  // Wgpt Bot Eval Results
  SET_WGPT_BOT_EVAL_RESULTS_UI_FLAG: 'SET_WGPT_BOT_EVAL_RESULTS_UI_FLAG',
  SET_WGPT_BOT_EVAL_RESULTS: 'SET_WGPT_BOT_EVAL_RESULTS',
  SET_WGPT_BOT_EVAL_RESULTS_META: 'SET_WGPT_BOT_EVAL_RESULTS_META',

  // Wgpt Bot Eval Recommendations
  SET_WGPT_BOT_EVAL_RECOMMENDATIONS_UI_FLAG:
    'SET_WGPT_BOT_EVAL_RECOMMENDATIONS_UI_FLAG',
  SET_WGPT_BOT_EVAL_RECOMMENDATIONS: 'SET_WGPT_BOT_EVAL_RECOMMENDATIONS',
  EDIT_WGPT_BOT_EVAL_RECOMMENDATION: 'EDIT_WGPT_BOT_EVAL_RECOMMENDATION',

  // Wgpt Integrations
  SET_WGPT_INTEGRATIONS_ZID_WEBHOOKS: 'SET_WGPT_INTEGRATIONS_ZID_WEBHOOKS',
  EDIT_WGPT_INTEGRATIONS_ZID_WEBHOOK: 'EDIT_WGPT_INTEGRATIONS_ZID_WEBHOOK',
  SET_WGPT_INTEGRATIONS_UI_FLAG: 'SET_WGPT_INTEGRATIONS_UI_FLAG',

  // Wgpt Onboarding
  SET_WGPT_ONBOARDING_UI_FLAG: 'SET_WGPT_ONBOARDING_UI_FLAG',
  SET_WGPT_ONBOARDING: 'SET_WGPT_ONBOARDING',

  // Wgpt SAML Providers
  SET_WGPT_SAML_PROVIDERS_UI_FLAG: 'SET_WGPT_SAML_PROVIDERS_UI_FLAG',
  SET_WGPT_SAML_PROVIDERS: 'SET_WGPT_SAML_PROVIDERS',
  ADD_WGPT_SAML_PROVIDER: 'ADD_WGPT_SAML_PROVIDER',
  EDIT_WGPT_SAML_PROVIDER: 'EDIT_WGPT_SAML_PROVIDER',
  DELETE_WGPT_SAML_PROVIDER: 'DELETE_WGPT_SAML_PROVIDER',

  // Wgpt Tasks
  SET_WGPT_TASKS_UI_FLAG: 'SET_WGPT_TASKS_UI_FLAG',
  SET_WGPT_TASKS: 'SET_WGPT_TASKS',
  ADD_WGPT_TASK: 'ADD_WGPT_TASK',
  EDIT_WGPT_TASK: 'EDIT_WGPT_TASK',
  DELETE_WGPT_TASK: 'DELETE_WGPT_TASK',

  // Wgpt Event Automations
  SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG: 'SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG',
  SET_WGPT_EVENT_AUTOMATIONS: 'SET_WGPT_EVENT_AUTOMATIONS',
  ADD_WGPT_EVENT_AUTOMATION: 'ADD_WGPT_EVENT_AUTOMATION',
  EDIT_WGPT_EVENT_AUTOMATION: 'EDIT_WGPT_EVENT_AUTOMATION',
  DELETE_WGPT_EVENT_AUTOMATION: 'DELETE_WGPT_EVENT_AUTOMATION',

  // Wgpt Task Executions
  SET_WGPT_TASK_EXECUTIONS_UI_FLAG: 'SET_WGPT_TASK_EXECUTIONS_UI_FLAG',
  SET_WGPT_TASK_EXECUTIONS_META: 'SET_WGPT_TASK_EXECUTIONS_META',
  SET_WGPT_TASK_EXECUTIONS: 'SET_WGPT_TASK_EXECUTIONS',

  // MACROS
  SET_MACROS_UI_FLAG: 'SET_MACROS_UI_FLAG',
  SET_MACROS: 'SET_MACROS',
  ADD_MACRO: 'ADD_MACRO',
  EDIT_MACRO: 'EDIT_MACRO',
  DELETE_MACRO: 'DELETE_MACRO',

  // Full Search
  FULL_SEARCH_SET: 'FULL_SEARCH_SET',
  CONTACT_SEARCH_SET: 'CONTACT_SEARCH_SET',
  CONTACT_SEARCH_SET_UI_FLAG: 'CONTACT_SEARCH_SET_UI_FLAG',
  CONVERSATION_SEARCH_SET: 'CONVERSATION_SEARCH_SET',
  CONVERSATION_SEARCH_SET_UI_FLAG: 'CONVERSATION_SEARCH_SET_UI_FLAG',
  MESSAGE_SEARCH_SET: 'MESSAGE_SEARCH_SET',
  ARTICLE_SEARCH_SET: 'ARTICLE_SEARCH_SET',
  CLEAR_SEARCH_RESULTS: 'CLEAR_SEARCH_RESULTS',
  MESSAGE_SEARCH_SET_UI_FLAG: 'MESSAGE_SEARCH_SET_UI_FLAG',
  ARTICLE_SEARCH_SET_UI_FLAG: 'ARTICLE_SEARCH_SET_UI_FLAG',
  FULL_SEARCH_SET_UI_FLAG: 'FULL_SEARCH_SET_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS_UI_FLAG:
    'SET_CONVERSATION_PARTICIPANTS_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS: 'SET_CONVERSATION_PARTICIPANTS',

  // Audit Logs
  SET_AUDIT_LOGS_UI_FLAG: 'SET_AUDIT_LOGS_UI_FLAG',
  SET_AUDIT_LOGS: 'SET_AUDIT_LOGS',
  SET_AUDIT_LOGS_META: 'SET_AUDIT_LOGS_META',

  // SLA
  SET_SLA_UI_FLAG: 'SET_SLA_UI_FLAG',
  SET_SLA: 'SET_SLA',
  ADD_SLA: 'ADD_SLA',
  EDIT_SLA: 'EDIT_SLA',
  DELETE_SLA: 'DELETE_SLA',

  // SLA Reports
  SET_SLA_REPORTS_UI_FLAG: 'SET_SLA_REPORTS_UI_FLAG',
  SET_SLA_REPORTS: 'SET_SLA_REPORTS',
  SET_SLA_REPORTS_METRICS: 'SET_SLA_REPORTS_METRICS',
  SET_SLA_REPORTS_META: 'SET_SLA_REPORTS_META',

  SET_TEAM_CONVERSATION_METRIC: 'SET_TEAM_CONVERSATION_METRIC',
  TOGGLE_TEAM_CONVERSATION_METRIC_LOADING:
    'TOGGLE_TEAM_CONVERSATION_METRIC_LOADING',

  // Assignment Policies
  SET_ASSIGNMENT_POLICIES_UI_FLAG: 'SET_ASSIGNMENT_POLICIES_UI_FLAG',
  SET_ASSIGNMENT_POLICIES: 'SET_ASSIGNMENT_POLICIES',
  SET_ASSIGNMENT_POLICY: 'SET_ASSIGNMENT_POLICY',
  ADD_ASSIGNMENT_POLICY: 'ADD_ASSIGNMENT_POLICY',
  EDIT_ASSIGNMENT_POLICY: 'EDIT_ASSIGNMENT_POLICY',
  DELETE_ASSIGNMENT_POLICY: 'DELETE_ASSIGNMENT_POLICY',
  SET_ASSIGNMENT_POLICIES_INBOXES: 'SET_ASSIGNMENT_POLICIES_INBOXES',
  SET_ASSIGNMENT_POLICIES_INBOXES_UI_FLAG:
    'SET_ASSIGNMENT_POLICIES_INBOXES_UI_FLAG',
  DELETE_ASSIGNMENT_POLICIES_INBOXES: 'DELETE_ASSIGNMENT_POLICIES_INBOXES',
  ADD_ASSIGNMENT_POLICIES_INBOXES: 'ADD_ASSIGNMENT_POLICIES_INBOXES',

  // Agent Capacity Policies
  SET_AGENT_CAPACITY_POLICIES_UI_FLAG: 'SET_AGENT_CAPACITY_POLICIES_UI_FLAG',
  SET_AGENT_CAPACITY_POLICIES: 'SET_AGENT_CAPACITY_POLICIES',
  SET_AGENT_CAPACITY_POLICY: 'SET_AGENT_CAPACITY_POLICY',
  ADD_AGENT_CAPACITY_POLICY: 'ADD_AGENT_CAPACITY_POLICY',
  EDIT_AGENT_CAPACITY_POLICY: 'EDIT_AGENT_CAPACITY_POLICY',
  DELETE_AGENT_CAPACITY_POLICY: 'DELETE_AGENT_CAPACITY_POLICY',
  SET_AGENT_CAPACITY_POLICIES_USERS: 'SET_AGENT_CAPACITY_POLICIES_USERS',
  SET_AGENT_CAPACITY_POLICIES_USERS_UI_FLAG:
    'SET_AGENT_CAPACITY_POLICIES_USERS_UI_FLAG',
  ADD_AGENT_CAPACITY_POLICIES_USERS: 'ADD_AGENT_CAPACITY_POLICIES_USERS',
  DELETE_AGENT_CAPACITY_POLICIES_USERS: 'DELETE_AGENT_CAPACITY_POLICIES_USERS',
  SET_AGENT_CAPACITY_POLICIES_INBOXES: 'SET_AGENT_CAPACITY_POLICIES_INBOXES',
  EDIT_AGENT_CAPACITY_POLICIES_INBOXES: 'EDIT_AGENT_CAPACITY_POLICIES_INBOXES',
  DELETE_AGENT_CAPACITY_POLICIES_INBOXES:
    'DELETE_AGENT_CAPACITY_POLICIES_INBOXES',

  // WGPT Custom Reports
  SET_WGPT_CUSTOM_REPORT_UI_FLAG: 'SET_WGPT_CUSTOM_REPORT_UI_FLAG',
  SET_WGPT_CUSTOM_REPORTS: 'SET_WGPT_CUSTOM_REPORTS',
  ADD_WGPT_CUSTOM_REPORT: 'ADD_WGPT_CUSTOM_REPORT',
  EDIT_WGPT_CUSTOM_REPORT: 'EDIT_WGPT_CUSTOM_REPORT',
  DELETE_WGPT_CUSTOM_REPORT: 'DELETE_WGPT_CUSTOM_REPORT',
  SET_WGPT_CUSTOM_REPORT_ACTIVE: 'SET_WGPT_CUSTOM_REPORT_ACTIVE',
  SET_WGPT_CUSTOM_REPORT_QUERY_RESULT: 'SET_WGPT_CUSTOM_REPORT_QUERY_RESULT',
  SET_WGPT_CUSTOM_REPORT_CHAT_MESSAGES: 'SET_WGPT_CUSTOM_REPORT_CHAT_MESSAGES',
  ADD_WGPT_CUSTOM_REPORT_CHAT_MESSAGE: 'ADD_WGPT_CUSTOM_REPORT_CHAT_MESSAGE',
  SET_WGPT_CUSTOM_REPORT_CHAT_REPORT_ID:
    'SET_WGPT_CUSTOM_REPORT_CHAT_REPORT_ID',
  SET_WGPT_CUSTOM_REPORT_LATEST_CHAT_CONFIG:
    'SET_WGPT_CUSTOM_REPORT_LATEST_CHAT_CONFIG',
  REMOVE_WGPT_CUSTOM_REPORT_PENDING_CHAT_MESSAGES:
    'REMOVE_WGPT_CUSTOM_REPORT_PENDING_CHAT_MESSAGES',

  // WGPT Custom Dashboards
  SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG: 'SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG',
  SET_WGPT_CUSTOM_DASHBOARDS: 'SET_WGPT_CUSTOM_DASHBOARDS',
  ADD_WGPT_CUSTOM_DASHBOARD: 'ADD_WGPT_CUSTOM_DASHBOARD',
  EDIT_WGPT_CUSTOM_DASHBOARD: 'EDIT_WGPT_CUSTOM_DASHBOARD',
  DELETE_WGPT_CUSTOM_DASHBOARD: 'DELETE_WGPT_CUSTOM_DASHBOARD',
  SET_WGPT_CUSTOM_DASHBOARD_ACTIVE: 'SET_WGPT_CUSTOM_DASHBOARD_ACTIVE',

  // WGPT Event Definitions
  SET_WGPT_EVENT_DEFINITION_UI_FLAG: 'SET_WGPT_EVENT_DEFINITION_UI_FLAG',
  SET_WGPT_EVENT_DEFINITIONS: 'SET_WGPT_EVENT_DEFINITIONS',
  ADD_WGPT_EVENT_DEFINITION: 'ADD_WGPT_EVENT_DEFINITION',
  EDIT_WGPT_EVENT_DEFINITION: 'EDIT_WGPT_EVENT_DEFINITION',
  DELETE_WGPT_EVENT_DEFINITION: 'DELETE_WGPT_EVENT_DEFINITION',
};
